import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProjectDetails = ({data}) => {
    const {url,image,client, server,name} = data;
    const navigate = useNavigate();
    const handleNavigate=(data)=>{
      console.log(data)
      navigate('/singleprojectdetails',{
        state:{
          data
        }
      })

    }
    return (
      <div>
        <p className='text-white text-3xl text-center mt-8'>{name}</p>
        <div className="flex justify-evenly items-start flex-wrap  ">
   
      
            <a className="card w-96 h-60 glass my-10" href={url}>
 
              <figure className="h-1/3 ">
                <img src={image} alt='' className='lg:m-0.5 sm:ml-5'/>
              </figure>
              
            </a>
            
       
        </div>
        <div className='flex flex-row justify-around text-center text-white'>
          <a href={url}><button className='btn py-0 px-4 bg-[#47aef74b] '>Live</button></a>
         <a href={client}> <button className='btn bg-[#47aef74b] '>Client</button></a>
          <a href={server}><button className='btn bg-[#47aef74b] '>Server</button></a>
          <a onClick={()=>handleNavigate(data)} href=''><button className='btn bg-[#47aef74b] '>Details</button></a>
        </div>
        
      </div>
    );
};

export default ProjectDetails;